<template>
    <v-row v-if="!$store.getters.progress" class="pb-offset ma-0">
		<v-col class="pa-0">
            <template v-if="showOnline">
                <show
                    :id="id"
                    :models="models"
                    :infos="infos"
                    :noButtons="noButtons"
                    :model-def="modelDef"
                    topClass=""
                    :key="showKey"
                ></show>

                <v-col class="pa-0" v-if="relations.interventions && relations.interventions.collection">
                    <trouble-interventions
                        :collection="relations.interventions.collection"
                        :headers="relations.interventions.info.fieldDefs"
                        :totals="models.trouble.totals.interventions"
                        :parent="models.trouble"
                        :totals-fields-config="interventionTotalsFields"
                        :totals-hidden="interventionTotalsHidden"
                        :intervention-products="relations.interventionproducts && relations.interventionproducts.collection ? relations.interventionproducts.collection : []"
                    ></trouble-interventions>
                </v-col>

                <v-col class="pa-0 pt-4" v-if="$store.getters.checkSettings('products_association_intervention') && relations.interventionproducts && relations.interventionproducts.collection">
                    <trouble-products
                        :collection="relations.interventionproducts.collection"
                        :headers="relations.interventionproducts.info.fieldDefs"
                        :totals="models.trouble.totals.products"
                        :title="$store.getters.checkSettings('product_in_trouble') ? 'Prodotti extra utilizzati' : 'Prodotti utilizzati'"
                        :totals-fields-config="productTotalsFields"
                        :totals-hidden="productTotalsHidden"
                    ></trouble-products>
                </v-col>

                <template v-if="$store.getters.checkSettings('product_in_trouble') && relations.producttrouble && relations.producttrouble.collection">
                    <v-col class="pa-0 pt-4">
                        <trouble-products
                            :collection="relations.interventionproducttrouble.collection"
                            :headers="relations.interventionproducttrouble.info.fieldDefs"
                            title="Prodotti utilizzati"
                        ></trouble-products>
                    </v-col>
                    
                    <v-col class="pa-0 pt-4">
                        <trouble-products
                            :collection="relations.producttrouble.collection"
                            :headers="relations.producttrouble.info.fieldDefs"
                            title="Prodotti a disposizione"
                        ></trouble-products>
                    </v-col>
                </template>

                <v-col class="pa-0 pt-4" v-if="total && !troubleTotalsHidden">
                    <trouble-totals
                        :total="total"
                        :subtotal="subtotal"
                        :tax="tax"
                        :totals-fields-config="troubleTotalsFields"
                        :totals-hidden="troubleTotalsHidden"
                    ></trouble-totals>
                </v-col>

                <slot name="activities">
                    <activities
                        class="pt-4"
                        model-class="trouble"
                        model-def="troubles"
                        :model-id="id"
                    ></activities>
                </slot>

                <slot name="maillogs">
                    <mail-logs
                        class="pt-4"
                        :card-class="['elevation-0 py-0']"
                        :quick-send="false"
                        model-class="trouble"
                        relation="troubles"
                        :model-id="id"
                    ></mail-logs>
                </slot>

                <slot name="sign"></slot>

                <slot name="upload">
                    <v-col class="pt-4 px-0">
                        <dms-uploader
                            :id="id"
                            attachable-type="trouble"
                        ></dms-uploader>
                    </v-col>
                </slot>

                <slot name="action">
                    <v-tooltip top v-if="!noButtons">
                        <template v-slot:activator="{ on: tooltip }">
                            <v-fab-transition>
                                <v-btn
                                    v-on="{ ...tooltip }"
                                    @click.native="$eventBusUtility.goTo($router, 'troubles-edit', id)"
                                    color="primary"
                                    dark
                                    fixed
                                    bottom
                                    right
                                    fab>
                                    <v-icon>edit</v-icon>
                                </v-btn>
                            </v-fab-transition>
                        </template>
                        <span>Modifica</span>
                    </v-tooltip>
                </slot>
            </template>
            <template v-else-if="readyOffline">
                <v-row class="mx-0 px-0 pb-offset">
                    <v-col class="pa-0" v-for="(model, m) in models" :class="setClass(m)" :key="m">
                        <v-card class="flex pa-0 round-card background-2" style="height: 100%" >
                            <v-card-title class="pa-3">
                                <p class="pl-2 pl-xl-3">{{ $trans(m) }}</p>
                                <v-spacer></v-spacer>
                                <template v-if="m == 'trouble'">
                                    <generate-intervention-button
                                        :params="{
                                            'icon': 'build',
                                            'create': true
                                        }"
                                        :model="{id: id}"
                                    ></generate-intervention-button>
                                    <signature-dialog
                                        ref="signatureDialog"
                                        :signature.sync="signature"
                                        :params="{tooltip: 'Firma Parziale', icon: 'mdi-draw-pen'}"
                                        :model-def="modelDef"
                                        :model="models.trouble"
                                    ></signature-dialog>
                                </template>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="pa-0">
                                <v-container class="px-0 py-2" fluid>
                                    <v-row class="mx-0" style="max-height: 350px; padding-right: 18px; overflow-y: auto;">
                                        <template v-for="(field, f) in getInfo(m)">
                                            <template v-if="field.text === 'Azioni'">
                                            
                                            </template>
                                            <template v-else-if="field.type === 'date'">
                                                <v-col :class="fieldClass[m] ? fieldClass[m] : 'col-12 col-sm-6 col-md-4 col-lg-3'" class="display-flex py-1 pt-0" :key="f">
                                                    <v-icon color="primary" class="ml-2 mr-4"></v-icon>
                                                    <v-list-item class="show-link pa-0 round-card" selectable>
                                                        <div class="align-self-center">
                                                            <div class="text-capitalize overline">{{ field.text }}</div>
                                                            <span class="fs13">{{ model[field.value] | date }}</span>
                                                        </div>
                                                    </v-list-item>                        
                                                </v-col>
                                            </template>
                                            <template v-else-if="field.type === 'boolean'">
                                                <v-col :class="fieldClass[m] ? fieldClass[m] : 'col-12 col-sm-6 col-md-4 col-lg-3'" class="display-flex py-1 pt-0" :key="f">
                                                    <v-icon color="primary" class="ml-2 mr-4"></v-icon>
                                                    <v-list-item class="show-link pa-0 round-card" selectable>
                                                        <div class="align-self-center">
                                                            <div class="text-capitalize overline">{{ field.text }}</div>
                                                            <span class="fs13">{{ model[field.value] === true ? 'Si' : 'No' }}</span>
                                                        </div>
                                                    </v-list-item>                        
                                                </v-col>
                                            </template>
                                            <v-col v-else :class="fieldClass[m] ? fieldClass[m] : 'col-12 col-sm-6 col-md-4 col-lg-3'" class="display-flex py-1 pt-0" :key="f">
                                                <v-icon color="primary" class="ml-2 mr-4"></v-icon>
                                                <v-list-item class="show-link pa-0 round-card" selectable>
                                                    <div class="align-self-center">
                                                        <div class="text-capitalize overline">{{ field.text }}</div>
                                                        <span class="fs13">{{ model[field.value] }}</span>
                                                    </div>
                                                </v-list-item>                        
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col class="pa-0 pt-4 col-12" v-if="relations.interventions && relations.interventions.collection && readyOffline">
                        <trouble-interventions
                            :collection="relations.interventions.collection"
                            :headers="relations.interventions.info.fieldDefs"
                        ></trouble-interventions>
                    </v-col>

                    <v-col class="pa-0 pt-4 col-12"
                    v-if="$store.getters.checkSettings('products_association_intervention') && 
                    relations.interventionproducts && 
                    relations.interventionproducts.info && 
                    relations.interventionproducts.info.info &&
                    relations.interventionproducts.info.info.fieldDefs">
                        <trouble-products
                            :collection="relations.interventionproducts.collection"
                            :headers="relations.interventionproducts.info.info.fieldDefs"
                            :totals="models.trouble.totals ? models.trouble.totals.products: null"
                        ></trouble-products>
                    </v-col>

                </v-row>
            </template>
		</v-col>
    </v-row>
</template>

<script>
    import Vue from 'vue'
	import Dexie from 'dexie'
    import Activities from '@/components/common/Activities'
    import MailLogs from '@/components/common/MailLogs'
	import SignatureDialog from '@/components/common/SignatureDialog'
    import TroubleTotals from '@/components/modules/tickets/TroubleTotals'
    import TroubleProducts from '@/components/modules/tickets/TroubleProducts'
    import TroubleInterventions from '@/components/modules/tickets/TroubleInterventions'
    import GenerateInterventionButton from '@/components/modules/tickets/GenerateInterventionButton'


    export default {
        name: 'trouble',
        components: {
            Activities,
            MailLogs,
            TroubleTotals,
            SignatureDialog,
            TroubleProducts,
            TroubleInterventions,
            GenerateInterventionButton
        },

        props: {
            id: Number,
            noButtons: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                infos: {},
                models: {},
                relations: {},
                fieldClass: {},
                readyOffline: false,
                modelDef: 'troubles',
                signature: '',
                showKey: 0,
                readyOnline: false
            }
        },

        methods: {

            initialize() {
                this.readyOnline = false
                this.readyOffline = false
                if(this.$store.getters.isOnline) {
                    this.axios.get(this.modelDef + '/' + this.id).then(response => {
                        this.models = response.data.models
                        this.infos = response.data.infos
                        this.relations = response.data.relations
                        this.showKey++
                        this.$store.commit('endProgress')
                        this.readyOnline = true
        
                    }, response => {
                        // error callback
                    })
                } else {

                    this.initializeOffline()

                }
            },

            initializeOffline() {
                var db = this.$store.getters.getDB

                db.troubles.where('id').equals(this.id).first().then(trouble => {
                    Vue.set(this.models, 'trouble',  trouble)
                    db.info_data.where('modelDef').equals('troubles').first().then(info_trouble => {
                        Vue.set(this.infos, 'trouble',  info_trouble)
                    })

                    if(trouble.contract_id) {
                        db.contracts.where('id').equals(trouble.contract_id).first().then(contract => {
                            Vue.set(this.models, 'contract',  contract)

                            db.info_data.where('modelDef').equals('contracts').first().then(info_contract => {
                                Vue.set(this.infos, 'contract',  info_contract)
                            })
                        })
                    }
                    if(trouble.asset_id) {
                        db.assets.where('id').equals(trouble.asset_id).first().then(asset => {
                            Vue.set(this.models, 'asset',  asset)

                            db.info_data.where('modelDef').equals('assets').first().then(info_asset => {
                                Vue.set(this.infos, 'asset',  info_asset)
                            })                            
                        })
                    }
                    if(trouble.tariff_id) {
                        db.tariffs.where('id').equals(trouble.tariff_id).first().then(tariff => {
                            Vue.set(this.models, 'tariff',  tariff)

                            db.info_data.where('modelDef').equals('tariffs').first().then(info_tariff => {
                                Vue.set(this.infos, 'tariff',  info_tariff)
                            })
                        })
                    }
                    if(trouble.company_id) {
                        db.companies.where('id').equals(trouble.company_id).first().then(company => {
                            Vue.set(this.models, 'company',  company)

                            db.info_data.where('modelDef').equals('companies').first().then(info_company => {
                                Vue.set(this.infos, 'company',  info_company)
                            })                            
                        })
                    }

                    Vue.set(this.relations, 'interventions',  {'collection': [], 'info': {}})
                    Vue.set(this.relations, 'interventionproducts',  {'collection': [], 'info': {}})

                    db.interventions.where('timecardable_id').equals(trouble.id).each(intervention => {
                        this.relations.interventions.collection.push(intervention)
                    }).then(() => {
                        _.forEach(this.relations.interventions.collection, (intervention) => {
                            db.interventionproduct.where('intervention_id').equals(intervention.id).each(product => {
                                this.relations.interventionproducts.collection.push(product)
                            })                        
                        })
                    })


                    db.info_data.where('modelDef').equals('interventions').first().then(info_intervention => {
                        Vue.set(this.relations.interventions, 'info',  info_intervention)
                    })
                    db.info_data.where('modelDef').equals('interventionproduct').first().then(info_interventionproduct => {
                        Vue.set(this.relations.interventionproducts, 'info',  {'info': info_interventionproduct.info, 'fieldDefs': info_interventionproduct.fieldDefs})
                    })

                    this.$store.commit('endProgress')
                    this.readyOffline = true
                })
            },

            setClass(i) {
                let index = Object.keys(this.models).indexOf(i)
                let padding = ''
                if(_.size(this.models) % 2 === 0) {
                    if(index % 2 === 0) {
                        if(this.$vuetify.breakpoint.xs) {
                            this.fieldClass[i] = 'col-12 col-sm-6 col-md-4'
                        }
                        this.fieldClass[i] = 'col-lg-4 col-sm-6 col-md-4 col-12'
                        if(this.$vuetify.breakpoint.lgAndUp) {
                            padding = 'pr-2'
                        }
                    } else {
                        if(this.$vuetify.breakpoint.xs) {
                            this.fieldClass[i] = 'col-12 col-sm-6 col-md-4'
                        }
                        if(this.$vuetify.breakpoint.lgAndUp) {
                            padding = 'pl-2'
                        }
                        this.fieldClass[i] = 'col-lg-4 col-sm-6 col-12 col-md-4'
                    }
                    return 'col-lg-6 col-12 pt-4 ' + padding
                } else if(_.size(this.models) % 2 !== 0) {
                    if(index === 0) {
                        this.fieldClass[i] = 'col-lg-3 col-sm-6 col-12'
                        return 'col-12 pt-4'
                    } else {
                        if(this.$vuetify.breakpoint.xs) {
                            this.fieldClass[i] = 'col-12 col-sm-6'
                            return 'col-lg-6 col-12 pt-4'
                        }
                        this.fieldClass[i] = 'col-lg-4 col-12 col-sm-6'
                        if(this.$vuetify.breakpoint.lgAndUp) {
                            if(index % 2 === 0) {
                                padding = 'pl-2'
                            } else {
                                padding = 'pr-2'
                            }
                        }
                        return 'col-lg-6 col-12 pt-4 ' + padding
                    }
                }
            }
        },

        mounted() {
            this.$eventBusUtility.$on('updateTroubleShow', () => {
                this.initialize()
                this.$eventBusUtility.$emit('refreshFileUploader')
            })
            this.$eventBusUtility.$on('offline', () => {
                this.initialize()
            })
            this.$eventBusUtility.$on('uploadedDB', () => {
                this.initialize()
            })
        },
        
        created() {
            this.initialize()
        },
        
        beforeDestroy() {
			this.$eventBusUtility.$off('updateTroubleShow')
			this.$eventBusUtility.$off('offline')
			this.$eventBusUtility.$off('uploadedDB')
		},
		
		computed: {
			interventionTotalsFields() {
				if (this.relations?.interventions?.info?.totals_config?.fields) {
					return this.relations.interventions.info.totals_config.fields
				}
				return null
			},

			interventionTotalsHidden() {
				return this.relations?.interventions?.info?.totals_config?.hidden || false
			},

			productTotalsFields() {
				if (this.relations?.interventionproducts?.info?.totals_config?.fields) {
					return this.relations.interventionproducts.info.totals_config.fields
				}
				return null
			},

			productTotalsHidden() {
				return this.relations?.interventionproducts?.info?.totals_config?.hidden || false
			},

			troubleTotalsFields() {
				if (this.infos?.trouble?.totals_config?.fields) {
					return this.infos.trouble.totals_config.fields
				}
				return null
			},

			troubleTotalsHidden() {
				return this.infos?.trouble?.totals_config?.hidden || false
			},

            showOnline() {
                return this.$store.getters.isOnline && this.readyOnline
            },

            getInfo(key) {
                return (key) => {
                    if(this.infos[key] && this.infos[key].fieldDefs) {
                        return this.infos[key].fieldDefs.filter((field) => {
                            return typeof this.models[key][field.value] !== 'undefined'
                        })
                    }
                }
            },

			total() {
                if(this.models.trouble && this.models.trouble.totals) {
                    return this.models.trouble.totals.interventions.total + this.models.trouble.totals.products.total
                } else {
                    return 0
                }
			},

			subtotal() {
                if(this.models.trouble && this.models.trouble.totals) {
                    return this.models.trouble.totals.interventions.subtotal + this.models.trouble.totals.products.subtotal
                } else {
                    return 0
                }
            },

			tax() {
                if(this.models.trouble && this.models.trouble.totals) {
				    return this.models.trouble.totals.interventions.tax + this.models.trouble.totals.products.tax
                } else {
                    return 0
                }
            },
		},
    }
</script>